import { FileFillerInterface } from '../../interfaces/file-filler.interface';
import { CalculationResponse } from '../../responses/calculation.response';
import { ExportFileInterface } from '../../interfaces/export-file.interface';
import { PDFDocument } from 'pdf-lib';
import { ExportTypeEnum } from '../../enums/export-type.enum';
import { ExportResourceEnum } from '../../enums/export-resource.enum';
import { ExportResourceProviderInterface } from '../../interfaces/export-resource-provider.interface';

export class Section84_1PdfFiller implements FileFillerInterface {
  constructor(
    private readonly exportResourcesProvider: ExportResourceProviderInterface,
  ) {
  }

  async fill(calculation: CalculationResponse): Promise<ExportFileInterface> {
    const fileString = await this.exportResourcesProvider.getResource(ExportResourceEnum.t2057_fill_17f);
    const pdfDoc = await PDFDocument.load(fileString, { ignoreEncryption: true });
    const form = pdfDoc.getForm();

    const fields = form.getFields();
    fields.forEach(field => {
      const type = field.constructor.name;
      const name = field.getName();

      if (type === 'PDFTextField') {
        switch (name) {
          case 'form1[0].Page1[0].Transferor[0].Pg1_TaxPayer_Name[0]':
            // @ts-ignore
            field.setText('bod');

          // default:
          //     // @ts-ignore
          //     field.setText("1");
        }
      }
    });
    const pdfBytes = await pdfDoc.save();

    return {
      fileName: `${calculation.id}.pdf`,
      fileBytes: pdfBytes,
      fileType: ExportTypeEnum.PDF,
    };
  }
}
